import { Room } from '@weblite/ts-action/room'
import { Message, RawWappMessage } from '@weblite/ts-action/message'
import { getWappTheme } from '$common/wapp-bar-theme'
import { isMessageFromClientUser } from '$logic/message'
import { getCallMessageStatusText } from '$logic/call'
import { t } from '$i18n'
import { calculateUnseenCount } from '$logic/room-seen'
import { Typography } from '@mui/material'

export function getLastMessageText(lastMessage?: Message): string | undefined {
  if (!lastMessage) return undefined

  if (lastMessage.type === 'CALL') {
    const { attachment, sender } = lastMessage
    return getCallMessageStatusText(attachment.status, sender.id)
  }

  if ('body' in lastMessage && lastMessage.body) return lastMessage.body
  if (
    lastMessage.type !== 'EVENT' &&
    'attachment' in lastMessage &&
    'wappId' in (lastMessage?.attachment || {})
  )
    return getWappTheme(
      (lastMessage as RawWappMessage)?.attachment?.wappId || '',
    ).name

  return undefined
}

export const ACTION_MAPPER: Record<string, string> = {
  TYPING: (
    <Typography component="span" variant="inherit" sx={{ color: 'inherit' }}>
      {t('chat.typing')}
      <Typography component="span" variant="inherit" sx={{ color: 'inherit' }}>
        ...
      </Typography>
    </Typography>
  ),
  RECORD_VOICE: t('chat.recordingVoice'),
  UPLOAD_FILE: t('chat.uploadingFile'),
  UPLOAD_PHOTO: t('chat.uploadingPhoto'),
  UPLOAD_VOICE: t('chat.uploadingVoice'),
  UPLOAD_VIDEO: t('chat.uploadingVideo'),
  UPLOAD_AUDIO: t('chat.uploadingAudio'),
}

export function getLastMessageStatus(
  lastMessage: Message | undefined,
  clientSeen: number | undefined,
  room: Room | undefined,
) {
  const { seenIid, receivedIid } = room || {}

  const lastMessageIid = lastMessage?.iid
  const fromMe = isMessageFromClientUser(lastMessage)
  const unseen = calculateUnseenCount(lastMessage, clientSeen, room)
  const isSeenByClient =
    fromMe && lastMessageIid && seenIid && lastMessageIid <= seenIid
  const received =
    fromMe &&
    lastMessageIid &&
    seenIid &&
    receivedIid &&
    lastMessageIid > seenIid &&
    lastMessageIid <= receivedIid

  return { unseen, seen: isSeenByClient, received, fromMe }
}
